<script setup lang="ts">
import type { MenuItem } from '@convatec/180medical-website/types/navigation'
import MegaColumn from '@convatec/180medical-website/app/components/layout/MegaColumn.vue'
import MegaPromo from '@convatec/180medical-website/app/components/layout/MegaPromo.vue'
import { computed } from 'vue'

const props = defineProps<{ items: MenuItem[] }>()
const active = ref()
function closeMenu() {
  active.value = null
}

const menuItems = computed(() =>
  props.items.map(item => ({
    id: item.contentGuid || item.slug || item.title.toLowerCase().replace(/\s+/g, '-'),
    label: item.title,
    target: item.target,
    promo: item.promo,
    slot: 'mega',
    children: item.children,
  })),
)
</script>

<template>
  <!-- as="div": NavHeader owns the labeled nav landmark; Reka's root would add a second -->
  <UNavigationMenu
    v-model="active"
    as="div"
    arrow
    variant="link"
    :items="menuItems"
    :unmount-on-hide="false"
    class="w-full justify-center bg-white shadow-lg overflow-visible"
    :ui="{
      item: 'relative block overflow-visible hover:bg-med-v-light-aqua group-data-[state=open]:bg-med-v-light-aqua',
      linkLabel: 'font-bold text-base px-4 py-2 inline-block text-med-deep-navy hover:text-med-deep-navy group-data-[state=open]:text-med-deep-navy gap-x-0.5 2xl:text-lg',
      viewport: 'w-full rounded-none',
      content: 'w-full',
      arrow: 'hidden',
    }"
  >
    <template #mega-content="{ item }">
      <div class="w-full flex justify-center bg-white">
        <div class="w-full flex justify-center text-sm leading-6">
          <div
            class="w-full relative before:block before:absolute before:top-0 before:left-0 before:right-0 before:bg-linear-to-b before:from-gray-900 before:to-transparent before:h-8 before:opacity-10"
          >
            <div class="max-w-350 mx-auto px-6 lg:px-10 xl:px-20 py-9 relative">
              <div class="grid w-full grid-cols-3 gap-8">
                <div class="flex flex-col gap-4">
                  <MegaColumn
                    v-for="group in item.children?.filter(c => c.column === 1)"
                    :key="group.title"
                    :group="group"
                    :close-menu="closeMenu"
                  />
                </div>
                <div class="flex flex-col gap-4">
                  <MegaColumn
                    v-for="group in item.children?.filter(c => c.column === 2)"
                    :key="group.title"
                    :group="group"
                    :close-menu="closeMenu"
                  />
                </div>
                <div class="flex flex-col gap-4">
                  <MegaPromo
                    v-if="item.promo"
                    :promo="item.promo"
                    :close-menu="closeMenu"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </UNavigationMenu>
</template>
